import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4af96b40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "expandable-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "textRef",
      class: _normalizeClass(["expandable-text", { 'line-clamp': !_ctx.isExpanded }]),
      style: _normalizeStyle({ '--lines': _ctx.lines })
    }, _toDisplayString(_ctx.text), 7),
    (_ctx.showButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "toggle-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleExpand && _ctx.toggleExpand(...args)))
        }, [
          _createTextVNode(_toDisplayString(_ctx.isExpanded ? '收起' : '展开') + " ", 1),
          _createElementVNode("span", {
            class: _normalizeClass(["arrow", { 'up': _ctx.isExpanded }])
          }, null, 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}